import store from '@/store'
import { ref } from '@vue/composition-api'
//* Method to fill param request from table 'Usuarios'
export const configTableUsuarios = () => {
  const tableColumns = [
    { key: 'id', label: 'Idmdl', sortable: true },
    { key: 'shortname', label: 'Nombre Salon Moodle', sortable: true },
    { key: 'startdate', label: 'Fechas_Inicio_y_Fin' },
    { key: 'summary', label: 'Descripción' },
    { key: 'numsections', label: 'Caracteristicas' },
    { key: 'opciones' },
  ]
  //* Params to fill table data & filters
  const configRequest = ref({
    wsType: 'wsmoodleadmin', //* WebService name
    wsParams: { action: 23, token: store.state.cuenta.session.token }, //* Request params
    actividades: null, //* Filter
    curso: null, //* Filter
    plan: null, // Filter
    periodo: null, // Filter
    filterGetter: 'salonesMoodle/filterSalonesMoodle', //* Getter function to filter data
  })
  return {
    tableColumns,
    configRequest,
  }
}
//* Load filter options with promises
export const useUsuariosCatalogos = () => {
  const statusOptions = [
    { label: 'Si', value: 'true' },
    { label: 'No', value: 'false' },
  ]
  const statusOptions2 = [
    { label: 'Si', value: '1' },
    { label: 'No', value: '0' },
  ]
  return { statusOptions, statusOptions2 }
}
